export default __webpack_public_path__ + "static/media/Rams.75d3a4ee.png";